import React, { SVGProps } from 'react'
export const FourthDefaultCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    viewBox="0 0 74 36"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M37.55 35c4.759 0 12.5.008 19.738.015l2.926.004C66.29 35.025 71.634 35 74 35v1c-2.364 0-7.698-.006-13.764-.012l-2.949-.003c-7.238-.008-14.98-.016-19.736-.016L0 36v-1h37.55Z"
      clipRule="evenodd"
    />
    <path
      fill="#7F7472"
      d="M6.514 1.7c-2.991.163-5.32.289-6.514.289V1C1.18 1 3.46.865 6.41.705 9.356.545 12.97.349 16.824.203c7.67-.289 16.255-.374 22.153.46 9.285 1.315 19.73.816 25.289.268.964-.213 2.66-.317 4.447-.319A38.61 38.61 0 0 1 74 1v1a39.673 39.673 0 0 0-5.285-.388c-1.802.002-3.418.11-4.26.301l-.03.007-.03.003c-5.59.554-16.145 1.063-25.558-.269-5.799-.82-14.3-.74-21.976-.451A622.95 622.95 0 0 0 6.514 1.7Z"
    />
  </svg>
)
